import { render, staticRenderFns } from "./SelfServiceLeftMenu.vue?vue&type=template&id=6b9acb2c&"
import script from "./SelfServiceLeftMenu.vue?vue&type=script&lang=js&"
export * from "./SelfServiceLeftMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports